import { resetStore, resetStoreNoReload } from './slices/loaderSlice';
import { user_actions } from '../actions/user_actions';
import { initial_basicInfo } from '../pages/loginSignup/signup/BasicInformation';
import { initial_businessInfo } from '../pages/loginSignup/signup/BusinessInformation';
import { initial_additionalInfo } from '../pages/loginSignup/signup/AdditionalInformation';
export const initialSelectedLocDetails = {
    TransactionNum: '',
    AvailableAmount: null,
    ApprovedAmount: null,
    status: '',
    ExpirationDate: '',
    RentalFleet: null,
};
const initialState = {
    userData: {
        email: null,
        firstName: null,
        lastName: null,
        isRoleApproved: 0,
        RoleType: '',
        PortalType: '',
        Country: '',
        ProgramName: '',
        Id: null,
        AccountAspireId: null,
        AccountType: null,
        IsDashboardTourCompleted: null,
        IsAllApplicationsTourCompleted: null,
    },
    isLoggedIn: false,
    session: {
        accessToken: '',
        refreshToken: '',
    },
    sessionId: '',
    signupFormInfo: Object.assign(Object.assign(Object.assign({}, initial_basicInfo), initial_businessInfo), initial_additionalInfo),
    loaderMessage: '',
    helpMail: '',
    selectedLocDetails: Object.assign({}, initialSelectedLocDetails),
    selectedLang: 'en',
    genricMarketingText: '',
    fieldConfig: {
        NorAppJson: {},
        LocAppJson: {},
        SchAppJson: {}
    },
    applicationDetails: {},
    impersonationDetails: {}
};
export function UserReducer(state = initialState, { type, payload }) {
    switch (type) {
        case 'persist/REHYDRATE': {
            if (payload && payload.User) {
                return Object.assign({}, state, payload.User);
            }
            else {
                return Object.assign({}, state);
            }
        }
        case user_actions.Constants.LoginSuccess:
            return Object.assign({}, state, {
                isLoggedIn: true,
                session: {
                    accessToken: payload.session.Token,
                    refreshToken: payload.session.RefreshToken,
                },
                userData: {
                    email: payload.session.Email,
                    firstName: payload.session.FirstName,
                    lastName: payload.session.LastName,
                    isRoleApproved: payload.session.RoleApproval,
                    RoleType: payload.session.RoleType,
                    PortalType: payload.session.PortalType,
                    Country: payload.session.Country,
                    ProgramName: payload.session.ProgramName,
                    Id: payload.session.Id,
                    AccountAspireId: payload.session.AccountAspireId,
                    AccountType: payload.session.AccountType,
                    IsDashboardTourCompleted: payload.session.IsDashboardTourCompleted,
                    IsAllApplicationsTourCompleted: payload.session.IsAllApplicationsTourCompleted
                }
            });
        case user_actions.Constants.TourStatusUpdated:
            return Object.assign({}, state, {
                userData: Object.assign(Object.assign({}, state.userData), payload)
            });
        case user_actions.Constants.sessionId:
            return Object.assign({}, state, {
                sessionId: payload
            });
        case user_actions.Constants.SessionRefresh:
            return Object.assign({}, state, {
                session: Object.assign(Object.assign({}, state.session), { accessToken: payload })
            });
        case user_actions.Constants.setSignupFormInfo:
            return Object.assign({}, state, {
                signupFormInfo: payload,
            });
        case user_actions.Constants.loaderMessage:
            return Object.assign({}, state, {
                loaderMessage: payload,
            });
        case user_actions.Constants.helpMail:
            return Object.assign({}, state, {
                helpMail: payload,
            });
        case user_actions.Constants.SELECTED_USER_LANG:
            return Object.assign({}, state, {
                selectedLang: payload,
            });
        case user_actions.Constants.GENERIC_MARKETING_TEXT:
            return Object.assign({}, state, {
                genricMarketingText: payload,
            });
        case user_actions.Constants.FIELD_CONFIG:
            return Object.assign({}, state, {
                fieldConfig: payload,
            });
        case user_actions.Constants.selectedLocDetails:
            return Object.assign({}, state, {
                selectedLocDetails: payload,
            });
        case resetStore.type:
        case resetStoreNoReload.type: {
            return Object.assign({}, state, initialState);
        }
        case user_actions.Constants.applicationDetails: {
            return Object.assign({}, state, {
                applicationDetails: payload
            });
        }
        case user_actions.Constants.impersonationDetails: {
            return Object.assign({}, state, {
                impersonationDetails: payload
            });
        }
        default:
            return state;
    }
}
